import {BaseRouteConfig} from "../../../core/components/router/models/base-route-config";
import {ROUTE_NAMES} from "../../../core/consts";
import {ReactLazyPreload} from "../../../core/components/router/react-lazy-preload";
import {AccumulatorRouteMetaDataModel} from "./accumulator-route.meta-data.model";

export class AccumulatorRouteConfig extends BaseRouteConfig {
  static injectables = [];

  constructor(props) {
    super(props);

    this.name = ROUTE_NAMES.accumulator;
    this.path = `/accumulator`;
    this.component = ReactLazyPreload(() => import("../components/accumulator-container" /* webpackChunkName: "accumulator-container" */ ));
    this.metadataType = AccumulatorRouteMetaDataModel;
  }
}